export { default as routes } from './routes'



// WEBPACK FOOTER //
// ./src/app/domains/user/index.js